import script from "./SizeChartResult.vue?vue&type=script&setup=true&lang=js"
export * from "./SizeChartResult.vue?vue&type=script&setup=true&lang=js"

import "./SizeChartResult.vue?vue&type=style&index=0&id=071e165d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-071e165d"]])

export default __exports__